$(function () {
  $(window).on("load resize", function () {
    $(window).scroll(function () {
      var scroll = $(this).scrollTop();
      var speed = scroll / 20;

      $(".floatingA").each(function () {
        $(this).css("margin-top", speed + "px");
      });
    });
  });

  $(".scroll-mark").on("click", function (e) {
    e.preventDefault();
    var pos = $(".top-lead").offset().top;
    $("html, body").animate({ scrollTop: pos }, 800);
  });

  $("#pagetop").on("click", function (e) {
    e.preventDefault();
    $("html, body").animate({ scrollTop: 0 }, 400);
  });

  AOS.init({
    offset: 200,
    // delay: 200,
    // easing: 'linear',
    duration: 800,
    // once: false
  });
});
